export default {
  "HitPaw Online Audio Converter": "HitPaw Онлайн Аудио Конвертер",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "Конвертируйте аудио в MP3, AAC, FLAC, WMA и другие форматы бесплатно.",
  'HitPaw Online Image Converter': 'Онлайн Конвертер Изображений HitPaw',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': 'Конвертируйте изображения в JPG, PNG, BMP, TIFF и другие форматы бесплатно.',
  'HitPaw Online Video Converter': 'HitPaw Онлайн Видео Конвертер',
  'Convert videos to any formats as your requirements.': 'Конвертируйте видео в любые форматы в соответствии с вашими требованиями.',
  'Add More Files': 'Добавление Дополнительных Файлов',
  'Convert to': 'Преобразовать в',
  'Ready': 'Готов',
  'Converting': 'Преобразование',
  'Video': 'Видео',
  'Audio': 'Аудио',
  'Image': 'Изображение',
  'Retry': 'Повторить попытку',
  'Download All': 'Скачать Все',
  'Download Desktop': 'Скачать на Рабочий стол',
  'Continue Editing': 'Продолжить редактирование',
  'Convert': 'Преобразовать формат',
  'Cut': 'Резать',
  'Speed': 'Переменить скорость',
  'Crop & Rotate': 'обрезка&поворот',
  'Resize': 'Изменить размер',
  'Extract': 'Извлечь видео и аудио',
  'Add Music': 'Добавить музыку',
  'Subtitles': 'Добавить субтитры',
  'Merge': 'Объединить',
  'Watermark Remover': 'Удалить водяной знак',
  'Add Watermark': 'Добавить водяной знак',
  'Please select a file to use': 'Пожалуйста, выберите файл для использования {{work}}',
  'Batch Processing': 'Пакетная обработка',
};
